<template>
  <div class="cropsManagement-page">
    <div class="all-content-container">

      <div class="table-content-container">
        <div class="table-title-container">
          <div class="title_boder">

            <div class="title-back">
              <h4>作物</h4>
              <p class="backBth" style="margin-top: 9px" @click="backBthCurrent()">
                <i class="el-icon-caret-left"></i>
                <span>返回</span>
              </p>
            </div>
            <el-button v-allow="'010102'" type="primary" class="adduser" @click="add()">添加</el-button>
            <!-- <el-button v-allow="'010102'" type="primary" class="adduser" @click="backBthCurrent()">返回决策模型</el-button> -->
          </div>

          <div class="table-content-title">
            <el-form :inline="true" class="demo-form-inline">
              <el-form-item label="作物：">
                <el-input v-model="name" placeholder="请输入作物" maxlength="20" clearable @clear="getGrowthCropList()"></el-input>
              </el-form-item>
              <el-form-item label="分组：">
                <el-cascader expand-trigger="hover" v-model="selectedCateKeys" :options="getAllGrowthCropList" :props="optionProps" placeholder="请选择分组" collapse-tags @change="chang_val" clearable></el-cascader>
              </el-form-item>
              <el-form-item>
                <el-button v-allow="'010101'" type="primary" @click="queryOnSubmit()">查询</el-button>
                <el-button @click="relruonSubmit">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="table-content" style="margin-top: 15px; border: none">
          <div class="table-table">
            <el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#f4f5f7' }">
              <el-table-column prop="name" label="生长作物" align="center"></el-table-column>
              <el-table-column prop="groupName" label="分组" align="center"></el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button v-allow="'010103'" type="text" @click="edit(scope.row.id)">编辑</el-button>
                  <el-button v-allow="'010104'" type="text" @click="del(scope.row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination-content-container" style="padding-top: 20px">
            <el-pagination background layout="prev, pager, next,jumper" class="pageTap" @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize" :total="total"></el-pagination>
          </div>
        </div>
        <div class="pagination-container">
          <el-dialog title="添加作物" :visible.sync="centerDialogVisible" width="650px" center style="z-index: 10000" :before-close="resetForm">
            <div class="info-content-container info-content-container-add">
              <el-form :inline="true" :model="dialogform" style="margin-left: 100px" :rules="dialogformRules" ref="dialogform">
                <el-form-item label="作物图片：" prop="image">
                  <el-upload class="avatar-uploader" :action="$serverUrl + '/pc/growthCrop/uploadImage'" :headers="headers" name="file" :limit="10" :on-exceed="handleExceed" :show-file-list="false" :on-success="handleAvatarSuccess" :on-progress="handleAvatarProgress" :before-upload="beforeAvatarUpload">
                    <img v-if="show" :src="dialogform.image" class="avatar" />
                    <i v-if="!show" class="avatar-uploader-icon">
                      <i class="el-icon-plus"></i>
                    </i>
                  </el-upload>
                </el-form-item>
                <el-form-item label="作物名称：" prop="name">
                  <el-input v-model="dialogform.name" placeholder="请输入作物名称" style="width: 344px" maxlength="20" clearable></el-input>
                </el-form-item>
                <el-form-item label-width="90px" label="分组：" prop="groupId">
                  <el-cascader expand-trigger="hover" style="width: 344px" v-model="dialogform.groupId" placeholder="请选择分组" :options="getAllGrowthCropList" :props="optionProps2" collapse-tags clearable></el-cascader>
                </el-form-item>
              </el-form>
            </div>
            <span slot="footer" class="dialog-footer1">
              <el-button @click="resetForm">取 消</el-button>
              <el-button type="primary" @click="submitForm('dialogform')">确 定</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'cropsManagement',
  data() {
    return {
      selectedCateKeys: [],
      zhongzhidap: '',
      optionProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true,
        multiple: false
      },
      optionProps2: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: false,
        multiple: true
      },
      multiple: true,
      options: [],
      dialogformName: '',
      dialogformModelStageId: [],
      show: false,
      headers: {
        // 身份验证
        AUTHORIZATION: sessionStorage.getItem('TOKEN')
      },
      dialogTitle: '', //弹框title :headers="headers"
      input: '',
      name: '', //作物
      groupName: '', //大棚name
      centerDialogVisible: false,
      currentPage: 1,
      total: 0,
      pagesize: 8,
      dialogform: {
        id: '',
        image: '',
        groupId: [],
        name: '',
        selectedCateKeys: []
      },
      dialogformRules: {
        image: [{ required: true, message: '请上传作物图片', trigger: 'change' }],
        name: [{ required: true, message: '请输入作物名称', trigger: 'blur' }],
        groupId: [{ required: true, message: '请选择分组', trigger: 'change' }]
      },

      id: '',
      tableData: [],
      srcList: [],
      isEdit: 0,
      getAllGrowthCropList: [],
      greenhouseId: ''
    }
  },
  created() {
    this.init()
  },
  methods: {
    resetForm() {
      this.centerDialogVisible = false
      this.$refs['dialogform'].resetFields()
    },
    // 保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 保存作物
          this.saveGrowthCrop()
        }
      })
    },
    // 大棚选择
    chang_val(val) {
      // 不是三级分类
      if (this.selectedCateKeys.length !== 2) {
        this.selectedCateKeys = []
        return
      }
      this.greenhouseId = val[val.length - 1][val[val.length - 1].length - 1]
    },
    // 数据请求
    init() {
      this.getGrowthCropList()
      this.getAllGrowthCrops()
    },
    //分页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
      this.getGrowthCropList() //列表数据
    },
    //  查询
    queryOnSubmit() {
      this.id = ''
      this.getGrowthCropList()
    },
    //重置
    relruonSubmit() {
      this.name = ''
      this.selectedCateKeys = []
      this.getGrowthCropList()
    },
    //新增
    add() {
      this.emUpty()
      this.centerDialogVisible = true
      this.dialogTitle = '添加作物'
      this.id = ''
      this.emUpty()
      this.show = false
    },
    //弹框取消按钮
    cancellation() {
      this.centerDialogVisible = false
      this.emUpty()
    },
    emUpty() {
      this.dialogform.image = ''
      this.dialogform.name = ''
      this.dialogform.selectedCateKeys = ''
    },
    //编辑
    edit(id) {
      this.isEdit = 1
      this.id = id
      this.emUpty()
      this.centerDialogVisible = true
      ;(this.dialogTitle = '编辑作物'), (this.dialogform.id = id)
      this.getGrowthCrop(id)
    },
    // 查询作物列表
    getGrowthCropList() {
      this.$api.system
        .getGrowthCropList(
          this.currentPage, //第几页，默认1
          this.pagesize, //默认展示多少条，默认10
          this.groupId, //大棚name
          this.id, //
          this.image, //图片
          this.name //名称
        )
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data
            this.total = res.count
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    // 删除
    del(id) {
      this.$confirm('是否删除？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then((res) => {
          this.$api.system.delfun(`/pc/growthCrop/delGrowthCrop`, id).then((res) => {
            // this.getUserMessageList();
            this.getGrowthCropList()
            this.$message({
              type: 'success',
              message: res.msg
            })
          })
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    // 保存作物
    saveGrowthCrop() {
      let groupId = ''
      if (this.dialogform.groupId) {
        this.dialogform.groupId.forEach((val) => {
          if (val.length == 2) {
            if (groupId.length > 0) {
              groupId += ','
            }
            groupId += val[1]
          }
        })
      }

      let data = new FormData()
      data.append('image', this.dialogform.image)
      data.append('id', this.id)
      data.append('name', this.dialogform.name)
      data.append('groupId', groupId)
      this.$api.system
        .saveGrowthCrop(data)
        .then((res) => {
          if (res.code == 200) {
            this.centerDialogVisible = false
            this.getGrowthCropList()
            this.isEdit = 0
            this.$message({
              type: 'success',
              message: res.msg
            })
          }
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    //查询作物详情getGrowthCrop
    getGrowthCrop(id) {
      this.$api.system
        .getGrowthCrop(
          id, // 主键id ，根据具体业务进行
          this.currentPage, //第几页，默认1
          this.pagesize //默认展示多少条，默认10
        )
        .then((res) => {
          if (res.code == 200) {
            ;(this.multiple = false), (this.show = true)
            this.dialogform.image = res.data.image
            this.dialogform.name = res.data.name

            // 处理分组id
            let groupIdArray = []
            if (res.data.groupId) {
              res.data.groupId.split(',').forEach((val) => {
                let parentGroupId = this.getParentGroupId(parseInt(val))
                if (parentGroupId > 0) {
                  groupIdArray.push([parentGroupId, parseInt(val)])
                }
              })
            }
            this.dialogform.groupId = groupIdArray
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    // 获取上级分组id
    getParentGroupId(groupId) {
      let parentGroupId = 0
      let children = []
      console.log(this.dialogform.groupId)
      this.getAllGrowthCropList.map((item) => {
        if (item.children) {
          console.log()
          children = item.children
          let isEnd = false
          children.every(function (val2) {
            if (val2.id == groupId) {
              parentGroupId = val2.parentId
              isEnd = true
            }
            return val2.id != groupId
          })
          return !isEnd
        }
      })

      return parentGroupId
    },
    // 查询全部
    getAllGrowthCrops() {
      this.$api.system
        .getGroupList()
        .then((res) => {
          if (res.code == 200) {
            this.getAllGrowthCropList = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    handleExceed(files, fileList) {
      this.$message.warning(`最多上传10张图片`)
    },
    handleAvatarSuccess(res, file) {
      if (res.code == 200) {
        this.srcList = []
        this.show = true
        this.$forceUpdate()
        this.dialogform.image = res.data
        this.$toaster.ok(res.msg)

        this.imgUpdateProgress = 100
        setTimeout(() => {
          this.isUpdateSuccess = false
          this.imgUpdateProgress = 0
        }, 200)
      }
    },
    handleAvatarProgress(event, file, fileList) {
      // 文件上传时的进度
      this.isUpdateSuccess = true
      var timer = setInterval(() => {
        this.imgUpdateProgress += 10
        if (this.imgUpdateProgress >= 90) {
          clearInterval(timer)
        }
      }, 200)
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isSize = file.size / 1024 / 1024 < 5

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 、PNG 格式!')
      }
      if (!isSize) {
        this.$message.error('上传图片大小不能超过 5MB!')
      }
      return isJPG && isSize
    },
    backBthCurrent() {
      this.$router.go(-1)
    }
  },
  computed: {
    // 当前选中id的最后一个
    groupId() {
      if (this.selectedCateKeys.length === 2) {
        return this.selectedCateKeys[1]
      }
      return null
    },
    // 当前选中id的最后一个
    groupId1() {
      if (this.dialogform.selectedCateKeys.length === 2) {
        return this.dialogform.selectedCateKeys[1]
      }
      return null
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/style/cropsManagement.scss';

li {
  padding-left: 10px;
}
.el-button--primary[data-v-f816515a] {
  margin-right: 5px;
}
.adduser {
  margin-top: 7px;
  margin-right: 11px;
}
</style>